import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { GetFeatureToggles } from "./feature-toggle.action";
import { FeatureToggleService } from "../service/feature-toggle.service";
import { FeatureToggleDataResponseDto } from "../dto/response/feature-toggle-response-dto.interface";
import { tap } from "rxjs";

export class FeatureToggleStateModel {
  data: FeatureToggleDataResponseDto[];
  isLoaded: boolean;
}

@State<FeatureToggleStateModel>({
  name: "featureToggle",
  defaults: {
    data: [],
    isLoaded: false}})
@Injectable()
export class FeatureToggleState {
  constructor(private featureToggleService: FeatureToggleService) {}

  @Selector()
  static isLoaded(state: FeatureToggleStateModel) {
    return state.isLoaded;
  }

  @Selector()
  static isInMaintenance(state: FeatureToggleStateModel) {
    if (!state.isLoaded) return null;
    return (
      state.data.find((toggle) => toggle.name === "maintenance")?.active ||
      false
    );
  }

  @Selector()
  static donateIsEnable(state: FeatureToggleStateModel) {
    return (
      state.data.find((toggle) => toggle.name === "donate")?.active || false
    );
  }

  @Selector()
  static creditCardIsEnable(state: FeatureToggleStateModel) {
    return (
      state.data.find((toggle) => toggle.name === "creditCard")?.active || false
    );
  }

  @Selector()
  static pixIsEnable(state: FeatureToggleStateModel) {
    return state.data.find((toggle) => toggle.name === "pix")?.active || false;
  }

  @Selector()
  static metaIsEnable(state: FeatureToggleStateModel) {
    return state.data.find((toggle) => toggle.name === "meta")?.active || false;
  }

  @Selector()
  static rhynothonIsEnable(state: FeatureToggleStateModel) {
    return (
      state.data.find((toggle) => toggle.name === "rhynothon")?.active || false
    );
  }

  @Selector()
  static planIsEnable(state: FeatureToggleStateModel) {
    return state.data.find((toggle) => toggle.name === "plan")?.active || false;
  }

  @Action(GetFeatureToggles)
  getFeatureToggles(
    ctx: StateContext<FeatureToggleStateModel>,
    _action: GetFeatureToggles,
  ) {
    return this.featureToggleService.getFeatureToggles().pipe(
      tap((response) => {
        const state = ctx.getState();
        ctx.patchState({
          ...state,
          data: response.data,
          isLoaded: true});
      }),
    );
  }
}
